module.exports = __webpack_public_path__ + "static/media/albers-covers.79190967.jpg";